import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persist } from "./store/store";
import "./Assets/Font/Aeonik/Aeonik-Air.otf";
import "./Assets/Font/Aeonik/Aeonik-Black.otf";
import "./Assets/Font/Aeonik/Aeonik-Bold.otf";
import "./Assets/Font/Aeonik/Aeonik-Light.otf";
import "./Assets/Font/Aeonik/Aeonik-Medium.otf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <CookiesProvider>
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persist}>
            <App />
          </PersistGate>
        </Provider>
      </React.StrictMode>
    </CookiesProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
